<div *ngIf="documentStages.length > 0 && profile" >
    <div class="grid">
        <div class="col-12" style="margin-bottom: 10px;">
            <p class="my-0">
                {{'UploadOrdersFilePage.Description' | translate}}
            </p>
        </div>

        <div class="col-12" *ngIf="deliveryInformation">
          <div class="info-section grid mx-1">
            <div class="col border-right section">
              <div class="row-info">
                <p class="label-info">{{'UploadOrdersFilePage.InfoDataDetail.ProgramIdText' | translate}}:</p>
                <p class="p-info">
                  {{directSaleProgramId ? directSaleProgramId : '(pending)' }}
                </p>
              </div>
              <div class="row-info">
                <p class="label-info">{{'UploadOrdersFilePage.InfoDataDetail.ImporterText' | translate}}:</p>
                <p class="p-info">{{deliveryInformation.orderDetails[0] ? deliveryInformation.orderDetails[0].importerCompanyName : '(pending)' }}</p>
              </div>
              <div class="row-info">
                <p class="label-info">{{'UploadOrdersFilePage.InfoDataDetail.ShippingCompanyText' | translate}}:</p>
                <p class="p-info">
                  {{ deliveryInformation.delivery.shippingCompanyName ? deliveryInformation.delivery.shippingCompanyName
                  : '(pending)'}}
                </p>
              </div>
              <div class="row-info">
                  <p class="label-info">{{'UploadOrdersFilePage.InfoDataDetail.ExportOrderText' | translate}}</p>
                  <p class="p-info">
                    {{orderNumber ? padWithLeadingZeros(orderNumber): '(pending)'}}
                  </p>
              </div>
            </div>

            <div class="col border-right section">
              <div class="row-info">
                <p class="label-info">{{'UploadOrdersFilePage.InfoDataDetail.BookingText' | translate}}:</p>
                <p class="p-info">
                  {{deliveryInformation.delivery.booking ? deliveryInformation.delivery.booking : '(pending)'}}
                </p>
              </div>
              <div class="row-info" *ngIf="deliveryInformation.delivery.transportType === 0">
                <p class="label-info">{{'UploadOrdersFilePage.InfoDataDetail.DeparturePortText' | translate}}:</p>
                <p class="p-info">
                  {{
                  deliveryInformation.delivery.departurePort ?
                  deliveryInformation.delivery.departurePort.name
                  : '(pending)' }}
                  </p>
              </div>
              <div class="row-info" *ngIf="deliveryInformation.delivery.transportType === 1">
                  <p class="label-info">{{'UploadOrdersFilePage.InfoDataDetail.DepartureAirportText' | translate}}:</p>
                  <p class="p-info">
                    {{
                    deliveryInformation.delivery.departureAirport ?
                    deliveryInformation.delivery.departureAirport.name
                    : '(pending)' }}
                    </p>
                </div>
              <div class="row-info" *ngIf="deliveryInformation.delivery.transportType === 0">
                <p class="label-info">{{'UploadOrdersFilePage.InfoDataDetail.DestinationPortText' | translate}}:</p>
                <p class="p-info">
                  {{
                      deliveryInformation.delivery.destinationPort ?
                      deliveryInformation.delivery.destinationPort.name
                      : '(pending)' }}
                </p>
              </div>
              <div class="row-info" *ngIf="deliveryInformation.delivery.transportType === 1">
                  <p class="label-info">{{'UploadOrdersFilePage.InfoDataDetail.DestinationAirportText' | translate}}:</p>
                  <p class="p-info">
                    {{
                        deliveryInformation.delivery.destinationAirport ?
                        deliveryInformation.delivery.destinationAirport.name
                        : '(pending)' }}
                  </p>
                </div>
              <div class="row-info">
                <p class="label-info">{{'UploadOrdersFilePage.InfoDataDetail.StackingStartText' | translate}}:</p>
                <p class="p-info">
                  {{deliveryInformation.delivery.stackingStart ?
                  (deliveryInformation.delivery.stackingStart |  date:'dd-MM-yyyy') : '(pending)'
                  }}
                </p>
              </div>
            </div>

            <div class="col border-right section">
              <div class="row-info">
                <p class="label-info">{{'UploadOrdersFilePage.InfoDataDetail.ContainerText' | translate}}:</p>
                <p class="p-info">
                  {{deliveryInformation.delivery.containerNumber ? deliveryInformation.delivery.containerNumber  :  '(pending)'}}
                </p>
              </div>
              <div class="row-info">
                <p class="label-info">{{'UploadOrdersFilePage.InfoDataDetail.DepositText' | translate}}:</p>
                <p class="p-info">{{deliveryInformation.delivery.containerDeposit ?
                deliveryInformation.delivery.containerDeposit : '(pending)' }}</p>
              </div>
              <div class="row-info">
                  <div class="row-info">
                      <p class="label-info">{{'UploadOrdersFilePage.InfoDataDetail.FridgeStorageName' | translate}}:</p>
                      <p class="p-info">{{deliveryInformation.orderDetails[0] ? deliveryInformation.orderDetails[0].fridgeStorageName : '' }}</p>
                    </div>
              </div>
              <div class="row-info">
                <p class="label-info">{{'UploadOrdersFilePage.InfoDataDetail.StackingEndText' | translate}}:</p>
                <p class="p-info">
                    {{deliveryInformation.delivery.stackingEnd ?
                    (deliveryInformation.delivery.stackingEnd |  date:'dd-MM-yyyy') : '(pending)'
                    }}</p>
              </div>
            </div>

            <div class="col section">
              <div class="row-info">
                <p class="label-info">ETA:</p>
                <p class="p-info">
                  {{deliveryInformation.delivery.eta ?
                  (deliveryInformation.delivery.eta |  date:'dd-MM-yyyy') : '(pending)'}}
                </p>
              </div>
              <div class="row-info">
                <p class="label-info">ETD:</p>
                <p class="p-info">{{deliveryInformation.delivery.etd ?
                (deliveryInformation.delivery.etd |  date:'dd-MM-yyyy') : '(pending)'}}</p>
              </div>
              <div class="row-info">
                <p class="label-info">DUS:</p>
                <p class="p-info">
                  {{deliveryInformation.delivery.dus ? deliveryInformation.delivery.dus : '(pending)'}}
                </p>
              </div>
              <div class="row-info">
                <p class="label-info">SPS:</p>
                <p class="p-info">
                    {{deliveryInformation.delivery.sps ? deliveryInformation.delivery.sps : '(pending)'}}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class=" col-12 flex justify-content-between " *ngIf="this.profile?.profileType === 'Exporter' && documentRequiredLoad">
            <div class="col-6">
                <p-button styleClass="p-button-sm"  icon="pi pi-upload" label="{{ 'OrderDetailTabComponent.LoadDocumentExporter' | translate }}" (onClick)="visibleOperationUploadDialog = true"></p-button>
            </div>
            <div class="col-6">
                <div class="progress-container" style="align-items: end;" *ngIf="selectedDocumentStage">
                    <p-progressBar [value]="getPercentageNumber(selectedDocumentStage)" [style]="{'height': '20px', 'margin-top': '13px', 'margin-bottom': '13px'}">
                    </p-progressBar>
                </div>
            </div>
        </div>
        <div class="col-12 mt-2">
            <div class="col-12 steps-container p-0">
                <p-steps class="document-steps" [model]="items" [readonly]="true" [activeIndex]="activeStep">

                </p-steps>
            </div>
        </div>
        <div class="col-5 mt-2">
            <div class="document-card" style="margin-bottom: 20px;">
                <p-accordion [multiple]="true" class="document-accordion">
                    <div *ngFor="let documentStage of documentStages; index as j">
                        <p-accordionTab (selected)="documentStage.id" (click)="expandAccordion(documentStage.id)"
                          [selected]="documentStage.selected" class="document-accordion-tab" onKeyPress="">
                            <ng-template pTemplate="header">
                                <div style="width: 100%;">
                                    <div class="flex justify-content-between align-content-center align-items-center">
                                      <div class="flex flex-row">

                                        <div class="flex justify-content-start align-content-center align-items-center">
                                          <!-- Flecha acordeón -->
                                          <i class="pi arrow-icon"
                                            [ngClass]="{
                                              'pi-chevron-down': documentStage.selected,
                                              'pi-chevron-right': !documentStage.selected
                                            }">
                                          </i>

                                          <!-- Nombre etapa -->
                                          <span class="pl-2 stage-name">
                                              {{getStageName(documentStage)}}
                                          </span>

                                          <!-- Estado completado -->
                                          <div *ngIf="isClearStage(documentStage.id) || (getUploadNumber(documentStage) === getRequiredUpload(documentStage) &&  getUploadNumber(documentStage) != 0)"
                                            class="flex align-items-center" style="padding-left: 5px;">
                                            <figure class="figure-circle-state-check" style="margin-right: 5px;" >
                                              <i class="pi pi-check" style="color: white; font-size: 0.7rem;"></i>
                                            </figure>
                                            <p class="status-text">
                                              {{'UploadOrdersFilePage.CompleteStateText' | translate}}
                                            </p>
                                          </div>

                                          <!-- Estado activo -->
                                          <div *ngIf="getUploadNumber(documentStage) > 0 && getUploadNumber(documentStage) < getRequiredUpload(documentStage) && !isClearStage(documentStage.id)"
                                            class="flex align-items-center" style="padding-left: 5px;">
                                            <figure class="figure-circle-state" style="margin-right: 5px;">
                                              <i class="pi pi-spin pi-spinner"  style="color: white; font-size: 0.7rem;"></i>
                                            </figure>
                                            <p class="status-text">
                                              {{'UploadOrdersFilePage.ActiveStateText' | translate}}
                                            </p>
                                          </div>
                                        </div>
                                      </div>

                                      <div class="flex flex-row">
                                        <!-- Cantidad archivos cargados -->
                                        <div class="flex align-items-center justify-content-start" style="margin-right: 5px;">
                                            <span class="loaded-text" style="font-weight: 500; font-size: 0.73rem;">
                                                {{'UploadOrdersFilePage.LoadedStateText' | translate}}:
                                                {{getUploadNumber(documentStage)}}/{{getRequiredUpload(documentStage)}}
                                            </span>
                                        </div>

                                      </div>
                                    </div>
                                </div>
                            </ng-template>
                            <div *ngIf="documentStage.documentTypes">
                                <div *ngFor="let documentType of documentStage.documentTypes">
                                    <div class="type-container" (click)="getFilesByType(documentType.id, documentType)"
                                          *ngIf="hasDocument(documentType.id); else hasNotDocument" onKeyPress=""
                                          [ngClass]="{'type-container-selected': documentTypeName === getTypeName(documentType)}">

                                        <!-- Documento cargado -->
                                        <div class="flex justify-content-start py-2 my-1">
                                            <div class="flex flex-row align-items-center">
                                                <i class="pi pi-check-circle figure-icon" style="font-size: 0.9rem;"></i>
                                                <div class="flex flex-column">
                                                  <span class="document-name">
                                                    {{getTypeName(documentType)}}
                                                  </span>
                                                  <!-- Mensaje ingresado -->
                                                  <span class="document-message-name">
                                                    {{getDocumentDescription(documentType.id)}}
                                                  </span>
                                                </div>
                                            </div>
                                            <div class="flex align-items-center" style="padding-left: 5px;">
                                                <figure class="figure-circle" *ngIf="HasPendingTypes(documentType.id)">
                                                </figure>
                                            </div>
                                        </div>
                                    </div>
                                    <ng-template #hasNotDocument>
                                        <div class="type-container" (click)="getFilesByType(documentType.id, documentType)" onKeyPress=""
                                          [ngClass]="{'type-container-selected': documentTypeName === getTypeName(documentType)}">

                                            <!-- Documento no cargado -->
                                            <div class="flex justify-content-start py-2 my-1 align-items-center">
                                                <div class="flex flex-row align-items-center">
                                                    <i *ngIf="!hasInformationLoad(documentType.informationLoad ?? '', documentType.requiredLoad ?? false)"
                                                      class="pi pi-circle-off figure-icon-off" style="font-size: 0.9rem;">
                                                    </i>
                                                    <i *ngIf="hasInformationLoad(documentType.informationLoad ?? '', documentType.requiredLoad ?? false)"
                                                      class="pi pi-check-circle figure-icon" style="font-size: 0.9rem;">
                                                    </i>
                                                    <span class="document-name">
                                                      {{documentType | documentTypeName}}
                                                    </span>
                                                </div>
                                                <div class="flex align-items-center" style="padding-left: 5px;">
                                                    <figure class=figure-circle *ngIf="HasPendingTypes(documentType.id)">
                                                    </figure>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-template>
                                </div>
                            </div>
                        </p-accordionTab>
                    </div>
                </p-accordion>
            </div>
        </div>
        <div class="col-7 mt-2">
          <div class="document-card px-3 pt-3 pb-4">

            <div *ngIf="selectedDocumentStage" class="grid flex justify-content-between">
              <div class="col-5">
                <h2 class="my-0" style="font-size: 14px; font-weight: 500">
                  {{'UploadOrdersFilePage.SelectedDocumentText' | translate}}:
                </h2>
              </div>
            </div>

            <div *ngIf="(!documentSelected || !documentRequiredLoad) && documentTypeName">
              <div class="document-data-section flex justify-content-between align-items-center" pRipple>
                <div class="flex justify-content-between my-1 w-full">
                  <div class="flex flex-row align-items-center">
                    <i class="pi pi-file figure-icon mr-1" style="font-size: 0.9rem;"></i>
                    <div class="flex flex-column">
                      <span class="document-name">
                        {{documentTypeName}}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div *ngIf="informationLoad && showInfo">
              <div *ngIf="deliveryInformation" class="mt-3 mb-3">
                  <div class="container-columns-top" *ngIf="informationLoad === 'truck'">
                      <div class="column-top">
                          <p class="label-info">{{'UploadOrdersFilePage.InfoDataDetail.DriverName' | translate}}:</p>
                          <p class="p-info">
                            {{deliveryInformation.delivery.truckDriverName}}
                          </p>
                      </div>
                      <div class="column-top">
                          <p class="label-info">{{'UploadOrdersFilePage.InfoDataDetail.LicenseTruck' | translate}}:</p>
                          <p class="p-info">
                            {{deliveryInformation.delivery.departurePatentTruck}}
                          </p>
                      </div>
                      <div class="column-top">
                          <p class="label-info">{{'UploadOrdersFilePage.InfoDataDetail.LicensedCar' | translate}}:</p>
                          <p class="p-info">
                            {{deliveryInformation.delivery.departurePatentCar}}
                          </p>
                      </div>
                  </div>
                  <div *ngIf="informationLoad === 'deposit'">
                      <div class="container-columns-top" *ngIf="deliveryInformation">
                          <div class="column-top">
                              <p class="label-info">{{'UploadOrdersFilePage.InfoDataDetail.DepositText' | translate}}:</p>
                              <p class="p-info">
                              {{deliveryInformation.delivery.containerDeposit}}
                              </p>
                          </div>
                      </div>
                  </div>
                  <div *ngIf="informationLoad === 'sps'">
                      <div class="container-columns-top" *ngIf="deliveryInformation">
                          <div class="column-top">
                              <p class="label-info">SPS:</p>
                              <p class="p-info">
                                {{deliveryInformation.delivery.sps ? deliveryInformation.delivery.sps : ''}}
                              </p>
                          </div>
                      </div>
                  </div>
                  <div *ngIf="informationLoad === 'container_number'">
                      <div class="container-columns-top" *ngIf="deliveryInformation">
                          <div class="column-top">
                              <p class="label-info">{{'UploadOrdersFilePage.InfoDataDetail.ContainerText' | translate}}:</p>
                              <p class="p-info">
                                {{deliveryInformation.delivery.dus ? deliveryInformation.delivery.containerNumber : ''}}
                              </p>
                          </div>
                      </div>
                  </div>
                  <div *ngIf="informationLoad === 'dus'">
                      <div class="container-columns-top" *ngIf="deliveryInformation">
                          <div class="column-top">
                              <p class="label-info">DUS:</p>
                              <p class="p-info">
                                {{deliveryInformation.delivery.dus ? deliveryInformation.delivery.dus : ''}}
                              </p>
                          </div>
                      </div>
                  </div>
              </div>
            </div>
            <div *ngIf="documentSelected && documentRequiredLoad">
              <div class="document-data-section flex justify-content-between align-items-center" pRipple>

                <div class="flex justify-content-between my-1 w-full">
                  <div class="flex flex-row align-items-center">
                    <i class="pi pi-file figure-icon mr-1" style="font-size: 0.9rem;"></i>
                    <div class="flex flex-column">
                      <span class="document-name">
                        {{documentTypeName}}
                      </span>
                      <!-- Mensaje ingresado -->
                      <span class="document-message-name">
                        {{'UploadOrdersFilePage.Message' | translate}}:
                        {{documentSelected.description}}
                      </span>
                    </div>
                  </div>
                  <div class="flex flex-row align-items-center justify-content-end text-right">
                    <div *ngIf="documentSelected.description != '' " onkeypress=""
                      (click)="showEmptyDialog(documentSelected.guid, documentSelected.isForwarderDocument, documentSelected.isQcDocument)"
                      class="edit-delete-btn">
                      <span class="edit-delete-text">
                        {{'UploadOrdersFilePage.DeleteEditMessage' | translate}}
                      </span>
                    </div>
                  </div>
                </div>

              </div>
              <div style="margin-bottom: 10px; margin-top: 10px;">
                <span style="font-size: .85rem; font-weight: 500;">
                  {{'UploadOrdersFilePage.AddMessageText' | translate}}:
                </span>
                <textarea
                  [(ngModel)]="documentDescription"
                  [style]="{'width': '100%'}" rows="3" cols="30"
                  autoResize="false"
                  [maxLength]="30"
                  class="message-textarea"
                  placeholder="{{'UploadOrdersFilePage.TypeHereText' | translate}}">
                </textarea>

                <div class="flex justify-content-between" style="text-align: start; vertical-align: text-top;">
                    <p style="font-size: 12px; font-weight: 500; margin: 0px;">
                      {{'UploadOrdersFilePage.MaxCharacterText' | translate}}
                    </p>
                    <p-button (click)="updateDescription(documentSelected.guid, documentSelected.isForwarderDocument, documentSelected.isQcDocument, documentSelected.operationDocumentTypeId, documentSelected.operationDocumentType)"
                      label="{{'UploadOrdersFilePage.AddButtonText' | translate}}"
                      styleClass="p-button-sm" class="my-1 btn-style"
                      onKeyPress="">
                    </p-button>
                </div>
                <div class="document-section-card document-section mt-2">
                  <div class="flex justify-content-between pb-2">
                      <div *ngIf="documentSelected.operationDocumentType"  style="text-align: start; vertical-align: text-top;">
                          <h3 class="document-title" style="margin: 0px;">{{'UploadOrdersFilePage.DocumentText' | translate}} {{getTypeName(documentSelected.operationDocumentType)}}-Fruzty </h3>
                      </div>
                      <p-button (click)="getOperationDocument(documentSelected.guid)"
                        label="{{'UploadOrdersFilePage.DownloadButtonText' | translate}}"
                        styleClass="p-button-outlined p-button-sm" class="btn-style"></p-button>
                  </div>
                  <div *ngIf="documentSelected && documentSelected.pdfUrl">
                    <div *ngIf="extension == 'pdf'">
                      <pdf-viewer [src]="getPdfSrc(documentSelected.pdfUrl)"
                      [render-text]="true"
                      [original-size]="false"
                      style="width: 100%; height: 500px"
                      ></pdf-viewer>
                    </div>
                    <div *ngIf="extension == 'xlsx'">
                    </div>
                    <div *ngIf="extension == 'png' || extension == 'jpg' || extension == 'jpeg'  ">
                      <img style="width: 100%; height: 500px"  [src]="getPdfSrc(documentSelected.pdfUrl)" >
                    </div>
                  </div>
              </div>
              </div>
            </div>
            <div *ngIf="documentsByTypes.length > 0 && documentRequiredLoad">
                <div *ngFor="let document of documentsByTypes index as i;">
                  <div (click)="changePdfSrc(document)" class="border-round-sm document-section flex justify-content-between align-items-center" pRipple *ngIf="document.id != documentSelected?.id" >
                    <div>
                        <span class="text-label" style="margin-left: 10px;">{{document.name}}</span> <br>
                            <span class="text-label" style="color: #333333; margin-left: 10px; font-weight: 400;">{{'UploadOrdersFilePage.Message' | translate}}:
                                <span style="color: #7E7E7E; font-weight: 400;">{{document.description}} -{{document.descriptionUpdate | date: 'dd/MM/YYYY HH:mm'}}
                            </span>
                        </span>
                    </div>
                  </div>
                </div>
                </div>
            <div *ngIf="documentsByTypes.length === 0 && !informationLoad">
                <div class="col-12 flex justify-content-center align-items-center">
                    <span class="material-symbols-outlined" style="font-size: 120px; color: #d7d7d7;">
                        warning
                    </span>
                  </div>
                  <p style="text-align: center; color: #d7d7d7;" *ngIf="documentTypeName != ''">
                    {{'UploadOrdersFilePage.DocumentsNotFoundText' | translate}}
                  </p>
                  <p style="text-align: center; color: #d7d7d7;" *ngIf="documentTypeName == ''">
                    {{'UploadOrdersFilePage.SelectDocumenTypeText' | translate}}
                  </p>
            </div>
          </div>
    </div>
</div>


<p-dialog [(visible)]="visibleEmptyDialog">
    <div class="col-12 flex justify-content-center align-items-center">
        <span class="material-symbols-outlined" style="font-size: 120px; color: red;">
            delete
        </span>
    </div>
    <h3 style="text-align: center;" >{{'UploadOrdersFilePage.DeleteMessageTitle' | translate}}</h3>
    <p style="text-align: center;">
        {{'UploadOrdersFilePage.DeleteMessageDescription' | translate}}
    </p>

    <ng-template pTemplate="footer">
      <p-button label="{{'UploadOrdersFilePage.CancelButton' | translate}}"  styleClass="p-button-outlined" (click)="visibleEmptyDialog = false" [loading]="loading"></p-button>
      <p-button label="{{'UploadOrdersFilePage.YesDeleteButton' | translate}}" (click)="emptyDescription()" [loading]="loading"></p-button>
    </ng-template>

  </p-dialog>

  <p-dialog header="{{'UploadDocumentDialog.Title' | translate}}" [(visible)]="visibleOperationUploadDialog" [style]="{width: '70%'}">
    <div class="grid">
        <div class="col-4">
            <input pInputText id="name" type="text"
            placeholder="{{'UploadDocumentDialog.NameDocumentPlaceholder' | translate}}" [(ngModel)]="name" style="width: 100%;"/>
        </div>
        <div class="col-4" >
            <p-dropdown [options]="operationDocumentTypes"
            [(ngModel)]="documentTypeViewId"
            placeholder="{{'UploadDocumentDialog.TypeDocumentPlaceholder' | translate}}"
            (onChange)="onSelectDocumentType($event)" styleClass="mb-2"
            [optionLabel]="profile.lang == 'es' ? 'nameEs' : 'name'" optionValue="id"></p-dropdown>
          </div>
        <div class="col-12">
            <p-fileUpload
            #fileUploader
            [showUploadButton]="false"
            [multiple]="false"
            accept=".pdf"
            name="pdf"
            [maxFileSize]="5000000"
            chooseLabel="{{'UploadDocumentDialog.DocumentPlaceholder' | translate}}"
            (onSelect)="onSelect($event)"/>
        </div>
    </div>
    <ng-template pTemplate="footer">
      <p-button label="{{'UploadDocumentDialog.BackButton' | translate}}" (onClick)="visibleOperationUploadDialog = false" [loading]="loading" styleClass="p-button-outlined"></p-button>
      <p-button label="{{'UploadDocumentDialog.UploadButton' | translate}}" (onClick)="upload()" [loading]="loading"></p-button>
  </ng-template>
  </p-dialog>

